import { createFileRoute } from '@tanstack/react-router';
import { pageTitle, usePageTitle } from '@/utils/pageTitle';
import { TenantTable } from '@/components/Pages/Tenants/TenantTable';
import { CreateEditTenantModal } from '@/components/Pages/Tenants/CreateEditTenantModal';
import { Box } from '@mui/joy';
import { SuperAdminRoute } from '@/components/SuperAdminRoute';

export const Route = createFileRoute('/_protected/tenants/')({
  component: RouteComponent,
  head: () => pageTitle('Empresas'),
});

function RouteComponent() {
  usePageTitle('Empresas');
  return (
    <SuperAdminRoute>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditTenantModal />
        </Box>
        <TenantTable />
      </Box>
    </SuperAdminRoute>
  );
}
